// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"368":"bf96bb6da1dbe13264f5","3982":"8ed09da46ee783eb23fb","6112":"f0a1592a1bdd9b74599e"}[chunkId] + ".chunk.css";
};